<div class="client-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.clients_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ clientObj.first_name }} {{ clientObj.last_name }}</h2>
    </div>
  </div>

  <div class="client-profile app-card">
    <div class="client-avatar-lg">{{ (clientObj.first_name || clientObj.username || '?').charAt(0).toUpperCase() }}</div>
    <div class="client-profile-info">
      <h3 class="client-profile-name">{{ clientObj.first_name }} {{ clientObj.last_name }}</h3>
      <p class="client-profile-username">&#64;{{ clientObj.username }}</p>
      <div class="client-meta-list">
        <div class="client-meta-item" *ngIf="clientObj.email">
          <span class="material-symbols-outlined">mail</span>
          <span>{{ clientObj.email }}</span>
        </div>
        <div class="client-meta-item" *ngIf="clientObj.phone_number">
          <span class="material-symbols-outlined">call</span>
          <span>{{ clientObj.phone_number }}</span>
        </div>
        <div class="client-meta-item" *ngIf="clientObj.address">
          <span class="material-symbols-outlined">location_on</span>
          <span>{{ clientObj.address }} {{ clientObj.city }} {{ clientObj.governorate }}</span>
        </div>
      </div>
    </div>
    <div class="client-profile-actions">
      <button class="lx-btn lx-btn--outline reset-pw-btn" (click)="toggleResetForm()">
        <span class="material-symbols-outlined">lock_reset</span>
        {{ showResetForm ? 'Cancel' : 'Reset Password' }}
      </button>
    </div>
  </div>

  <!-- Reset Password Panel -->
  <div class="reset-pw-panel app-card" *ngIf="showResetForm">
    <div class="reset-pw-header">
      <span class="material-symbols-outlined">lock_reset</span>
      <h4>Reset Password for {{ clientObj.first_name || clientObj.username }}</h4>
    </div>

    <div class="reset-pw-success" *ngIf="resetSuccess">
      <span class="material-symbols-outlined">check_circle</span>
      Password has been reset successfully.
    </div>

    <div class="reset-pw-body" *ngIf="!resetSuccess">
      <div class="reset-pw-field">
        <label>New Password</label>
        <input
          type="password"
          [(ngModel)]="newPassword"
          placeholder="At least 6 characters"
          class="lx-input"
        />
      </div>
      <div class="reset-pw-field">
        <label>Confirm Password</label>
        <input
          type="password"
          [(ngModel)]="confirmPassword"
          placeholder="Repeat new password"
          class="lx-input"
        />
      </div>

      <div class="reset-pw-error" *ngIf="resetError">
        <span class="material-symbols-outlined">error</span>
        {{ resetError }}
      </div>

      <div class="reset-pw-footer">
        <button class="lx-btn lx-btn--danger" (click)="resetPassword()" [disabled]="resetLoading">
          <span class="material-symbols-outlined">{{ resetLoading ? 'hourglass_top' : 'lock_reset' }}</span>
          {{ resetLoading ? 'Resetting…' : 'Confirm Reset' }}
        </button>
      </div>
    </div>
  </div>

  <div class="lx-section-header">
    <span class="material-symbols-outlined">shopping_bag</span>
    <h3 class="lx-section-title">{{ 'lbl.orders' | translate }}</h3>
  </div>

  <div class="app-card client-orders-card">
    <div class="lx-table-wrap">
      <table class="lx-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.products' | translate }}</th>
            <th>{{ 'lbl.date' | translate }}</th>
            <th>{{ 'lbl.method' | translate }}</th>
            <th>{{ 'lbl.paid' | translate }}</th>
            <th>{{ 'status.delivered' | translate }}</th>
            <th>{{ 'lbl.total' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr style="cursor: pointer" (click)="orderDetails(item.id)" *ngFor="let item of order_arr">
            <td class="cell-muted">{{ item.id }}</td>
            <td>{{ item.OrdersProducts.length }}</td>
            <td class="cell-date">{{ item.issue_date | date : "EEEE d MMMM y" }}</td>
            <td>
              <span class="status-badge method">{{ (item.cashed == true ? 'status.cash' : 'status.vodafone') | translate }}</span>
            </td>
            <td>
              <span class="status-badge" [class.paid]="item.paid != null" [class.cancelled]="item.paid == null">
                {{ (item.paid != null ? 'status.yes' : 'status.no') | translate }}
              </span>
            </td>
            <td>
              <span class="status-badge" [class.paid]="item.delivered != null" [class.cancelled]="item.delivered == null">
                {{ (item.delivered != null ? 'status.yes' : 'status.no') | translate }}
              </span>
            </td>
            <td class="cell-price">{{ item.total_price }} <span class="cell-currency">LE</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lx-empty" *ngIf="order_arr?.length === 0">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">shopping_bag</span>
      </div>
      <h3>{{ 'empty.client_orders' | translate }}</h3>
      <p>{{ 'empty.client_orders_sub' | translate }}</p>
    </div>
  </div>

</div>
